<template>
    <div  :style="{'height':clientHeight-90+'px'}">
            <div >
                <div class="m-portlet m-b-10">
                    <div class="m-portlet__body">
                        <el-form label-width="100px">
                            <el-row :gutter="20">
                                <el-col :span="6" v-if="!all_headTeacher">
                                    <el-form-item label="班主任">
                                        <el-select v-model="headTeacher_id"  placeholder="请选择班主任" remote clearable
                                                   @change="handleChange()">
                                            <el-option
                                                    v-for="item in headTeachers"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="选择学期">
                                        <el-select v-model="semester_id"  placeholder="请选择学期"  remote clearable
                                                   @change="handleChange()">
                                            <el-option
                                                    v-for="item in semesters"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="选择类型">
                                        <el-select v-model="types"
                                                   clearable
                                                   placeholder="请选择类型"
                                                   multiple
                                                   remote
                                                   @change="handleChange()">
                                            <el-option
                                                    v-for="item in array_type"
                                                    :key="item.id"
                                                    :label="item.name"
                                                    :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <div class="m-portlet m-b-0" :style="{'height':(clientHeight-230)+'px'}">
                    <div class="m-portlet__body" v-loading="loading">
                        <el-table
                                :data="studentCarts"
                                style="width: 100%"
                                :height="clientHeight-350"
                                size="middle">
                            <el-table-column prop="student_name" label="学生" min-width="10%"></el-table-column>
                            <el-table-column prop="headTeacher_name" label="班主任"  min-width="30%"></el-table-column>
                            <el-table-column prop="class_name" label="课程"  min-width="20%"></el-table-column>
                            <el-table-column prop="semester_name" label="学期"  min-width="15%"></el-table-column>
                            <el-table-column prop="sum_price" label="金额"  min-width="10%"></el-table-column>
                            <el-table-column prop="teacher_name" label="老师"  min-width="10%"></el-table-column>
                            <el-table-column prop="finished_period" label="已签到"  min-width="5%"></el-table-column>
                        </el-table>
                        <!--分页-->
                        <div class="text-center m-t-10">
                            <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="10"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path:"/cartTracking/list",
                semesters:[],
                headTeachers:[],
                headTeacher_id:'',
                semester_id:'',
                types:[],
                studentCarts:[],
                loading: true,
                all_headTeacher:false,
                array_type:[
                    {
                        id:0,
                        name:'未收费(签到=0)'
                    },
                    {
                        id:1,
                        name:'未处理试听(签到=1)'
                    },
                    {
                        id:2,
                        name:'欠费(签到>=2)'
                    }
                ],
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
            };
        },
        created() {
            this.handleCreate();
            this.handleIndex();
            this.handleShow();
        },
        computed: {
            right_level() {
                return this.$store.state.user.employee.right_level;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            handleCreate(){
                //建立webSocket链接
                this.$wApi.addListen(this.path,this.handleData);
            },
            handleShow() {
                this.$wApi.send(this.path,'init',{});
            },
            handleData(event,data){
                switch (event) {
                    case 'init':
                        this.headTeachers =data.headTeachers;
                        this.semesters=data.semesters;
                        this.all_headTeacher=data.all_headTeacher;
                        break;
                    case 'list':
                        this.total = data.total;
                        this.studentCarts = data.studentCarts;
                        this.loading = false;
                        break;
                    case 'list_error':
                        this.total = 0;
                        this.studentCarts = [];
                        this.loading = false;
                }
            },
            handleChange(){
                this.loading = true;
                this.handleIndex();
            },
            handleIndex(currentPage = 1) {
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': this.currentPage,
                    'currentPageSize': this.currentPageSize,
                    'semester_id': this.semester_id,
                    'types': this.types,
                    'headTeacher_id': this.headTeacher_id
                });
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndex(this.currentPage, this.currentPageSize)
            },
        }
    }
</script>

<style scoped>

</style>